import React from "react";
import { formatINR } from "../../api";

const ITEMS = [
  ["uses", "Times used", (v) => v],
  ["sales", "Sales", formatINR],
  ["discount_given", "Discount given", formatINR],
  ["commission_earned", "Commission earned", formatINR],
  ["commission_paid", "Commission paid", formatINR],
  ["commission_pending", "Commission pending", formatINR],
];

export const PromoStats = ({ stats, className = "" }) => (
  <div className={`grid grid-cols-2 md:grid-cols-6 gap-px bg-[var(--sand)] border border-[var(--sand)] ${className}`}>
    {ITEMS.map(([k, label, fmt]) => (
      <div key={k} className="bg-white p-4">
        <p className="text-[10px] tracking-[0.18em] uppercase text-[var(--espresso)]/55">{label}</p>
        <p data-testid={`promo-stat-${k}`} className="font-serif-display text-2xl mt-1">{fmt(stats[k])}</p>
      </div>
    ))}
  </div>
);
